module.exports = __webpack_public_path__ + "img/screenshot_board_5_super_color_collapsed.b6f3fa8d.png";